import jQuery from 'jquery';

;(function($){
    "use strict";
    /*jslint browser: true*/
    /*global $:false */
    
    if(!$.depage){
        $.depage = {};
    }

    var matched, browser;

    // Use of jQuery.browser is frowned upon.
    // More details: http://api.jquery.com/jQuery.browser
    // jQuery.uaMatch maintained for back-compat
    var uaMatch = function( ua ) {
            ua = ua.toLowerCase();

            var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
                    /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
                    /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
                    /(msie) ([\w.]+)/.exec( ua ) ||
                    ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
                    [];

            return {
                    browser: match[ 1 ] || "",
                    version: match[ 2 ] || "0"
            };
    };

    matched = uaMatch( navigator.userAgent );
    browser = {};

    if ( matched.browser ) {
            browser[ matched.browser ] = true;
            browser.version = matched.version;
    }

    // Chrome is Webkit, but Webkit is also Safari.
    if ( browser.chrome ) {
            browser.webkit = true;
    } else if ( browser.webkit ) {
            browser.safari = true;
    }
    if (browser.safari && /iphone/.test(navigator.userAgent.toLowerCase())) {
        browser.iphone = true;
        browser.ios = true;
    }
    if (browser.safari && /ipad/.test(navigator.userAgent.toLowerCase())) {
        browser.ipad = true;
        browser.ios = true;
    }

    $.depage.browser = browser;
})(jQuery);
